import React from 'react';

const WhatWeDo = () => (
  <div className="WhatWeDo">
    <h1>What We Do</h1>
    <h2>Management</h2>
    <p>
      We believe that an artist’s vision is what drives an artist’s career. Our
      goal is to come alongside the artist and help them hone that vision into
      something that is profitable and sustainable. We pride ourselves in our
      ability to function as true strategic partners at every stage of an
      artist’s project and at all points in their careers. We work in tandem
      with each artist to establish objectives, create a clear sense of what
      success will look like and engage in ongoing dialogue, evaluation and
      analysis as we work toward our shared goals.
    </p>
    <h2>Publicity</h2>
    <p>
      Every artist is passionate about what he or she does, but what an artist
      needs is a writer and a publicist who can condense their story into a
      piece that demands to be heard. Amelia Tritico brings over 5 years
      experience of advocating for independent artists on regional and national
      press campaigns.
    </p>
  </div>
);

export default WhatWeDo;



// WEBPACK FOOTER //
// ./src/pages/what-we-do/index.js